import { FlexRow } from '@components/FlexRow';
import { SearchBar } from '@components/SearchBar';
import { Apps, RemoveRedEye } from '@mui/icons-material';
import { Box, Button, IconButton, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
}));

export const defaultFilters = {
    status: 'active',
};

export const BlogFilter = ({
    viewMode,
    changeViewMode,
    onQueryChange,
    totalDocs,
}: {
    viewMode: 'list' | 'grid',
    totalDocs: number;
    changeViewMode: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onQueryChange: (query: string) => void;
    filter?: { status: string };
}) => {
    const theme = useTheme();
    return (
        <>
            <Container>
                <FlexRow>
                    <SearchBar onChange={onQueryChange}
                        endAdornment={
                            <Box sx={{
                                display: 'flex', alignItems: 'center', gap: 1,
                                padding: '0 12px',
                                borderLeft: theme => `dashed 1px ${theme.palette.border.main}`,
                                color: theme.palette.mode === 'dark' ? '#fff' : '#4239b0',
                            }}>
                                {totalDocs}
                            </Box>
                        }
                    />
                </FlexRow>
                <FlexRow>
                    <Box
                        sx={{
                            border: theme => `1px solid ${theme.palette.darkGrey.main}`,
                            borderRadius: '12px',
                            display: 'flex',
                        }}>
                        <IconButton
                            onClick={changeViewMode}
                            value="grid"
                            sx={{
                                px: 1.5,
                                borderColor: theme =>
                                    viewMode === 'grid' ? theme.palette.primary.main : theme.palette.secondary.main,
                                background: theme => (viewMode === 'grid' ? theme.palette.primary.main : 'none'),
                                borderRadius: '12px',
                                '&:hover': {
                                    background: theme => theme.palette.backgroundPilsurface.main,
                                }
                            }}>
                            <Apps sx={{ fill: theme => theme.palette.secondary.main }} />
                        </IconButton>
                        <IconButton
                            target='_blank'
                            component="a"
                            href={process.env.REACT_APP_PUBLIC_WEB_URI + '/blog'}
                            sx={{
                                px: 1.5,
                                borderColor: theme =>
                                    viewMode === 'list' ? theme.palette.primary.main : theme.palette.secondary.main,
                                background: theme => (viewMode === 'list' ? theme.palette.primary.main : 'none'),
                                borderRadius: '12px',
                            }}>
                            <RemoveRedEye sx={{ fill: theme => `${theme.palette.mode === 'dark' ? theme.palette.secondary.main : '#939393'}` }} />
                        </IconButton>
                    </Box>
                    <Button
                        sx={{
                            backgroundColor: '#4239B0',
                            '&:hover': {
                                backgroundColor: theme => theme.palette.backgroundPilsurface.main,
                            }
                        }
                        }
                        variant="contained"
                        startIcon={<i className="fi fi-br-plus" style={{
                            fontSize: '12px',
                            color: 'var(--Neutral-White, #FFF)',
                        }} />}
                        component={Link}
                        to="/blog/create">
                        <Typography sx={{
                            color: 'var(--Neutral-White, #FFF) !important',
                            textAlign: "center",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "24px",
                            fontSize: '16px'
                        }}>Ajouter</Typography>
                    </Button>
                </FlexRow>
            </Container>
        </>
    );
};


export default BlogFilter;
